import { URL_BASE, URL_BASE_ASISTENCIAS, URL_DEV_UTILIDADES, URL_BASE_POLIZARIO, URL_GSEGUROS_DATOS, URL_EDEGA_VALIDAR_CONTRATO, URL_EDEGA_DETALLE_RECLAMO } from "../../constants/url";
import {
  composeErrorNotification,
  composeSuccessNotification,
} from "../../utils/composeNotification";
import { get, post } from "../../utils/fetch";
import { notification } from "./notificationActions";
import { types } from "../types/types";

/**
 * obtener servicios por campaña ID
 * GET /api/asistencias/ServiciosByCampaniaID/{campaniaID}
 */
export const startGetServiciosByCampania = (campaniaID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ASISTENCIAS}/ServiciosByCampaniaID/${campaniaID}`;
    const result = await get(url);

    if (result.code === 0) {
      dispatch({
        type: types.storeServicios,
        payload: result.data,
      });
      return { success: true, data: result.data };
    }

    dispatch(
      notification(
        composeErrorNotification(
          "Error de conexión - ServiciosByCampaniaID",
          `${result.error}`
        )
      )
    );
    return { success: false, error: result.error };
  };
};

/**
 * obtener campos de un servicio específico
 * GET /api/asistencias/GetCampos/{servicioID}
 */
export const startGetCamposServicio = (servicioID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ASISTENCIAS}/GetCampos/${servicioID}`;
    const result = await get(url);

    if (result.code === 0) {
      dispatch({
        type: types.setCapturaCampos,
        payload: result.data,
      });
      return { success: true, data: result.data };
    }

    dispatch(
      notification(
        composeErrorNotification(
          "Error de conexión - GetCampos",
          `${result.error}`
        )
      )
    );
    return { success: false, error: result.error };
  };
};

/**
 * consultar validador
 * GET /api/ConsultaValidador/Consulta/{validador1}/{campaniaID}
 */
export const startConsultaValidador = (validador1, campaniaID) => {
  return async (dispatch) => {
    const url = `${URL_BASE}/api/ConsultaValidador/Consulta/${validador1}/${campaniaID}`;
    const result = await get(url);

    if (result.code === 0) {
      dispatch({
        type: types.storeValidadorInfo,
        payload: result.data,
      });
      return { success: true, data: result.data };
    }

    dispatch(
      notification(
        composeErrorNotification(
          "Error de conexión - Consulta Validador",
          `${result.error}`
        )
      )
    );
    return { success: false, error: result.error };
  };
};

/**
 * autorizar servicio con clave de supervisor
 * POST /api/asistencias/AutorizarServicio
 * body: { claveAutorizacion: string }
 */
export const startAutorizarServicio = (claveAutorizacion) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ASISTENCIAS}/AutorizarServicio`;
    const body = { claveAutorizacion };
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch({
        type: types.setCaptura,
        payload: result.data,
      });
      return { success: true, data: result.data };
    }

    dispatch(
      notification(
        composeErrorNotification("Autorización Error", `${result.error}`)
      )
    );
    return { success: false, error: result.error };
  };
};

/**
 * crear asistencia inicial (Fase 1 - Datos Generales)
 * POST /api/asistencias/CreaAsistenciaInicial
 * body: captura + usuarioID + campaniaID + CuentaEspecialGS (opcional)
 */
export const startCreaAsistenciaInicial = (body) => {
  return async (dispatch) => {
    const url = `${URL_BASE}/api/Captura2/CrearAsistenciaInicial`;
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)));
      dispatch({
        type: types.storeAsistenciaID,
        payload: result.data,
      });
      return { success: true, data: result.data };
    }

    dispatch(
      notification(
        composeErrorNotification(
          "Error de conexión - CreaAsistenciaInicial",
          `${result.error}`
        )
      )
    );
    return { success: false, error: result.error };
  };
};

/**
 * guardar datos de servicio (Fase 2)
 * POST /api/asistencias/PostFase3
 * body: captura completa
 */
export const startPostFase3 = (body) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ASISTENCIAS}/PostFase3`;
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)));
      return { success: true, data: result.data };
    }

    dispatch(
      notification(composeErrorNotification("Error - PostFase3", `${result.error}`))
    );
    return { success: false, error: result.error };
  };
};

/**
 * terminar captura y generar servicio (Fase 3 - Geo-Datos)
 * POST /api/asistencias/TerminaCaptura
 * body: captura + usuarioID + campaniaID
 */
export const startTerminaCaptura = (body) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ASISTENCIAS}/TerminaCaptura`;
    const result = await post(url, body);

    if (result.code === 0) {
      return { success: true, data: result.data };
    }

    dispatch(
      notification(
        composeErrorNotification(
          "Error de conexión - TerminaCaptura",
          `${result.error}`
        )
      )
    );
    return { success: false, error: result.error };
  };
};

/**
 * obtener datos de asistencia inicial por ID
 * GET /api/Captura2/GetAsistenciaInicial/{asistenciaID}
 */
export const startGetAsistenciaInicial = (asistenciaID) => {
  return async (dispatch) => {
    const url = `${URL_BASE}/api/Captura2/GetAsistenciaInicial/${asistenciaID}`;
    const result = await get(url);

    if (result.code === 0) {
      dispatch({
        type: types.setCaptura,
        payload: result.data,
      });
      return { success: true, data: result.data };
    }

    dispatch(
      notification(
        composeErrorNotification(
          "Error de conexión - GetAsistenciaInicial",
          `${result.error}`
        )
      )
    );
    return { success: false, error: result.error };
  };
};

/**
 * guardar origen y destino
 * POST /api/Captura2/CapturaOrigenDestino
 */
export const startCapturaOrigenDestino = (body) => {
  return async (dispatch) => {
    const url = `${URL_BASE}/api/Captura2/CapturaOrigenDestino`;
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification("Origen/Destino guardado")));
      return { success: true, data: result.data };
    }

    dispatch(
      notification(
        composeErrorNotification(
          "Error - CapturaOrigenDestino",
          `${result.error}`
        )
      )
    );
    return { success: false, error: result.error };
  };
};

/**
 * terminar captura
 * POST /api/Captura2/capturaTerminada
 */
export const startCapturaTerminada = (body) => {
  return async (dispatch) => {
    const url = `${URL_BASE}/api/Captura2/CapturaTerminada`;
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification("Captura terminada")));
      return { success: true, data: result.data };
    }

    dispatch(
      notification(
        composeErrorNotification(
          "Error - capturaTerminada",
          `${result.error}`
        )
      )
    );
    return { success: false, error: result.error };
  };
};

/**
 * obtener historial por numero de serie
 * GET /api/Captura2/GetHistorialPorNumeroSerie/{numeroSerie}
 */
export const startGetHistorialPorNumeroSerie = (numeroSerie) => {
  return async (dispatch) => {
    const url = `${URL_BASE}/api/Captura2/GetHistorialPorNumeroSerie/${encodeURIComponent(numeroSerie)}`;
    const result = await get(url);

    if (result.code === 0) {
      return { success: true, data: result.data };
    }

    dispatch(
      notification(
        composeErrorNotification(
          "Error de conexión - Historial Número de Serie",
          `${result.error}`
        )
      )
    );
    return { success: false, error: result.error };
  };
};

/**
 * setear datos de captura en el store
 */
export const setCrearServiciosV2Captura = (payload) => ({
  type: types.setCaptura,
  payload,
});

/**
 * setear cliente ID en el store
 */
export const setCrearServiciosV2ClienteID = (clienteID) => ({
  type: types.setClienteID,
  payload: clienteID,
});

export const cleanCrearServiciosV2ValidaInfo = () => ({
  type: types.storeValidadorInfo,
  payload: { servicios: [] },
});

/**
 * limpiar errores de validador en el store
 */
export const cleanErroresBuscaValidador = () => ({
  type: types.cleanErroresBuscaValidador,
  payload: null,
});

/**
 * setear errores de validador en el store
 */
export const setErrBuscaValidador = (errores) => ({
  type: types.setErrBuscaValidador,
  payload: errores,
});

/**
 * Consulta polizario El Águila (V2) - retorna noEncontrado
 */
export const startGetListaV2 = (validador1) => {
  return async (dispatch) => {
    dispatch({ type: types.setLoadingPolizario, payload: true });
    const url = `${URL_BASE_POLIZARIO}/Elaguila/GetByPolizaExacta/${validador1}`;
    const result = await get(url);
    const lista = result.code === 0 && Array.isArray(result.data) ? result.data : [];
    const noEncontrado = lista.length === 0;
    dispatch({ type: types.storeElAguilaLista, payload: lista });
    dispatch({ type: types.setVistaResultados, payload: 1 });
    dispatch({ type: types.setLoadingPolizario, payload: false });
    return { noEncontrado };
  };
};

export const startQueryChubbV2 = (validador1) => {
  return async (dispatch) => {
    // Prende el spinner (loadingPolizario → true)
    dispatch({ type: types.setLoadingPolizario, payload: true });
    // Limpia la póliza anterior para que no parpadee (chubbPoliza → null)
    dispatch({ type: types.storeChubbPoliza, payload: null });
    // Arma la URL con el folio limpio de espacios
    const url = `${URL_DEV_UTILIDADES}/Chubb/Buscarpoliza/${encodeURIComponent(validador1.trim())}`;
    // Espera a que responda la API
    const result = await get(url);
    // Si la API contestó OK (code 0) guardo el dato; si no, null
    const poliza = result.code === 0 ? result.data : null;
    // Publica el resultado (la póliza, o null si falló / no la encontró)
    dispatch({ type: types.storeChubbPoliza, payload: poliza });
    // Marca "ya se buscó" (vistaResultados → 1)
    dispatch({ type: types.setVistaResultados, payload: 1 });
    // Apaga el spinner (loadingPolizario → false)
    dispatch({ type: types.setLoadingPolizario, payload: false });
    // Devuelve si la póliza no trae policyNumber
    return { noEncontrado: !poliza?.policyNumber };
  };
};

/**
 * Consulta polizario GS (V2) - retorna noEncontrado
 */
export const startQueryGSegurosV2 = (datosForm) => {
  return async (dispatch) => {
    dispatch({ type: types.setLoadingGSeguros, payload: true });
    const body = {
      sucursal: datosForm.sucursal,
      ramo: datosForm.ramo,
      poliza: datosForm.poliza,
      inciso: datosForm.inciso,
    };
    const result = await post(URL_GSEGUROS_DATOS, body);
    if (result.code === 0) {
      dispatch({ type: types.setGSegurosResponse, payload: result.data });
      dispatch({ type: types.setGSegurosEmision, payload: result.data.emision });
      dispatch({ type: types.setVistaGSeguros, payload: 1 });
      dispatch({ type: types.setLoadingGSeguros, payload: false });
      const estatusEmision = result.data?.emision?.estatus;
      const noEncontrado = estatusEmision === "Asistencia vial no amparada";
      return { noEncontrado };
    } else {
      dispatch({ type: types.setGSegurosResponse, payload: null });
      dispatch({ type: types.setVistaGSeguros, payload: 0 });
      dispatch({ type: types.setLoadingGSeguros, payload: false });
      return { noEncontrado: true };
    }
  };
};

/**
 * consulta polizario Edega - valida contrato y obtiene detalle de reclamo
 */
export const startQueryEdegaV2 = (validador1) => {
  return async (dispatch) => {
    dispatch({ type: types.setLoadingEdega, payload: true });

    const contratoResult = await post(URL_EDEGA_VALIDAR_CONTRATO, { folio: validador1 });
    const contrato = contratoResult.code === 0 ? contratoResult.data?.result : null;
    const siUid = contrato?.si_uid;

    if (contrato?.tieneReclamo === true) {
      const detalleResult = siUid ? await get(`${URL_EDEGA_DETALLE_RECLAMO}/${siUid}`) : null;
      const detalle = detalleResult?.code === 0 ? detalleResult.data?.result : null;

      dispatch({ type: types.setEdegaContrato, payload: contrato });
      dispatch({ type: types.setEdegaDetalleReclamo, payload: detalle || {} });
      dispatch({ type: types.setVistaEdega, payload: 1 });
      dispatch({ type: types.setLoadingEdega, payload: false });
      return { noEncontrado: true, bloqueado: true };
    }

    if (contrato?.tieneReclamo !== false) {
      dispatch({ type: types.setEdegaContrato, payload: contrato || {} });
      dispatch({ type: types.setEdegaDetalleReclamo, payload: {} });
      dispatch({ type: types.setVistaEdega, payload: 0 });
      dispatch({ type: types.setLoadingEdega, payload: false });
      return { noEncontrado: true, bloqueado: true };
    }

    dispatch({ type: types.setEdegaContrato, payload: contrato });
    dispatch({ type: types.setEdegaDetalleReclamo, payload: {} });
    dispatch({ type: types.setVistaEdega, payload: 0 });
    dispatch({ type: types.setLoadingEdega, payload: false });

    return { noEncontrado: false, bloqueado: false, ct_uid: contrato?.ct_uid };
  };
};

/**
 * obtener campos de servicio
 * GET /api/asistencias/GetListaItemsByID/{listaID}
 */
export const startGetListaItems = (listaID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ASISTENCIAS}/GetListaItemsByID/${listaID}`;
    const result = await get(url);

    if (result.code === 0) {
      return { success: true, data: result.data };
    }

    dispatch(
      notification(
        composeErrorNotification(
          "Error de conexión - GetListaItemsByID",
          `${result.error}`
        )
      )
    );
    return { success: false, error: result.error };
  };
};

/**
 * obtener talleres de General de Seguros
 * GET /gsdbconsultas/GetDatosTalleresAgencias
 */
export const startGetTalleresGeneralSeguros = () => {
  return async (dispatch) => {
    const url = `${URL_DEV_UTILIDADES}/gsdbconsultas/GetDatosTalleresAgencias`;
    const result = await get(url);

    if (result.code === 0) {
      return { success: true, data: result.data };
    }

    dispatch(
      notification(
        composeErrorNotification(
          "Error al cargar talleres",
          `${result.error}`
        )
      )
    );
    return { success: false, error: result.error };
  };
};
